/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { changeAddressInput, entryState, entryAccount, accountOrders, updateAccountAddress, updateAccountEmail, updateAccountPassword, updateAccountConsents } from "../shop/connect";
var account = {
  init: function init() {
    if ($('#js-account').length > 0) {
      // Get orders.
      accountOrders();
    } else if (window.location.hash.length > 1 && ['login', 'register', 'forgot'].indexOf(window.location.hash.slice(1)) !== -1) {
      entryState(window.location.hash.slice(1));
    } else if (window.location.search.indexOf('id') !== -1) {
      entryState('reset');
    } else {
      entryState('login');
    }
    $("#js-accountEntryForm,#js-accountAddressForm,#js-accountEmailForm,#js-accountPasswordForm").on("keydown blur", "input", function (e) {
      if ($(e.currentTarget).attr('type') === 'checkbox') return;
      var id = $(e.currentTarget).attr("name");
      var value = $(e.currentTarget).val();
      changeAddressInput("address", id, value);
    });
    $('#js-accountAddressForm').on('change', 'select', function (e) {
      var id = $(e.currentTarget).attr("name");
      var value = $(e.currentTarget).val();
      changeAddressInput("address", id, value);
    });
    $('#js-accountEntryForm,#js-accountConsentForm').on('change', 'input:checkbox', function (e) {
      var id = $(e.currentTarget).attr("name");
      var value = $(e.currentTarget).prop('checked');
      var group = id !== 'termsAndConditions' ? 'address' : false;
      changeAddressInput(group, id, value);
    });
    $('#js-toggleRegister').on('click', function (e) {
      e.preventDefault();
      entryState('registerLogin');
    });
    $('#js-forgot').on('click', function (e) {
      e.preventDefault();
      entryState('forgot');
    });
    $('#js-toggleForgot').on('click', function (e) {
      e.preventDefault();
      entryState('loginForgot');
    });
    $('#js-accountEntryForm').on('submit', function (e) {
      e.preventDefault();
      var $submit = $('#js-accountEntryForm button[type="submit"]');
      $submit.html($submit.text() + ' <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>').prop('disabled', true).addClass('is-loading');
      entryAccount().then(function () {
        return $submit.prop('disabled', false).removeClass('is-loading');
      }).catch(function () {
        return $submit.prop('disabled', false).removeClass('is-loading');
      });
    });
    $('#js-accountOrders').on('click', '.js-toggleOrder', function (e) {
      e.preventDefault();
      $(e.currentTarget).toggleClass('is-expanded');
      $(e.currentTarget).closest('.js-accountOrder').find('.js-accountOrderDetails').slideToggle();
    });
    $('#js-accountOrders').on('click', '.js-loadMoreOrders', function (e) {
      e.preventDefault();
      accountOrders();
    });
    $('.js-formToggle').on('click', function (e) {
      e.preventDefault();
      $(e.currentTarget).closest('.js-formEdit').toggleClass('is-editable');
      if ($(e.currentTarget).closest('.js-formEdit').hasClass('is-editable')) {
        $(e.currentTarget).text($(e.currentTarget).data('cancel'));
      } else {
        $(e.currentTarget).text($(e.currentTarget).data('edit'));
      }
    });
    $('#js-accountAddressForm').on('submit', function (e) {
      e.preventDefault();
      var $this = $(e.currentTarget);
      updateAccountAddress().then(function () {
        // Close form
        $this.closest('.js-formEdit').find('.js-formToggle').trigger('click');
      });
    });
    $('#js-accountEmailForm').on('submit', function (e) {
      e.preventDefault();
      var $this = $(e.currentTarget);
      updateAccountEmail().then(function (response) {
        if (response.type === 'SELECTION_ERROR_REGISTERED') return;
        console.log('DEBUG: response', response);

        // Close form
        $this.closest('.js-formEdit').find('.js-formToggle').trigger('click');
        // Clear fields after to avoid seeing change.
        $('#js-accountEmailForm').find('input').val('').end().find('#address-emailOld').val(response.data.loggedIn.email);
      });
    });
    $('#js-accountPasswordForm').on('submit', function (e) {
      e.preventDefault();
      var $this = $(e.currentTarget);
      updateAccountPassword().then(function (response) {
        if (response.type === 'SELECTION_ERROR_PASSWORD') return;
        // Close form
        $this.closest('.js-formEdit').find('.js-formToggle').trigger('click');
        $('#js-selectionErrorPassword').hide();
        // Clear fields after to avoid seeing change.
        $('#js-accountPasswordForm').find('input').val('');
      });
    });
    $('#js-accountConsentForm').on('submit', function (e) {
      e.preventDefault();
      var $this = $(e.currentTarget);
      // Only update consents not other possibly filled in information.
      updateAccountConsents().then(function () {
        $this.closest('.js-formEdit').find('.js-formToggle').trigger('click');
      });
    });
  },
  finalize: function finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};
export default account;


// WEBPACK FOOTER //
// ./scripts/routes/account.js